"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmInputSelect = void 0;
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-return-assign */
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Icon_1 = require("../Icon");
const useCombobox_1 = require("./useCombobox");
const field_1 = require("../FieldControl/field");
const input_1 = require("../FieldControl/input");
const button_1 = require("../FieldControl/button");
exports.SmInputSelect = (0, react_1.forwardRef)((_a, ref) => {
    var { id, label, message, invalid, disabled, items, icon, onIconClick, iconLabel, selectOnly = false } = _a, props = __rest(_a, ["id", "label", "message", "invalid", "disabled", "items", "icon", "onIconClick", "iconLabel", "selectOnly"]);
    const { value, isOpen, filteredOptions, listitemRef, listboxRef, comboboxRef, onComboboxClick, onComboboxKeyDown, onComboboxChange, onComboboxBlur, onItemClick, } = (0, useCombobox_1.useCombobox)(items, selectOnly, props.value);
    const listId = (0, react_1.useMemo)(() => label.toLowerCase().replace('', '-'), [label]);
    (0, react_1.useImperativeHandle)(ref, () => comboboxRef.current);
    return (react_1.default.createElement(field_1.SmFieldTemplate, { id: id, type: "select", label: label, disabled: disabled, invalid: invalid, message: message },
        react_1.default.createElement(input_1.SmInputTemplate, Object.assign({}, props, { id: id, ref: comboboxRef, type: "text", message: message, invalid: invalid, disabled: disabled, role: "combobox", "aria-haspopup": "listbox", "aria-autocomplete": "list", "aria-expanded": isOpen, "aria-controls": `${listId}-listbox`, value: value, readOnly: selectOnly, onClick: (e) => {
                var _a;
                onComboboxClick();
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }, onChange: (e) => {
                var _a;
                onComboboxChange(e);
                (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e.target.value, e);
            }, onKeyDown: (e) => {
                var _a;
                onComboboxKeyDown(e);
                (_a = props.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }, onBlur: (e) => {
                var _a;
                onComboboxBlur();
                (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
            } })),
        react_1.default.createElement(button_1.SmInputButtonTemplate, { "aria-expanded": isOpen, "aria-controls": `${listId}-listbox`, disabled: disabled, onClick: (e) => {
                onComboboxClick();
                onIconClick === null || onIconClick === void 0 ? void 0 : onIconClick(e);
            }, title: iconLabel, icon: icon !== null && icon !== void 0 ? icon : react_1.default.createElement(Icon_1.SmIcon, { name: `arrow_drop_${isOpen ? 'up' : 'down'}` }), onBlur: () => {
                onComboboxBlur();
            } }),
        react_1.default.createElement("ul", { id: `${listId}-listbox`, className: `c-select ${isOpen ? '-expanded' : ''}`, role: "listbox", ref: listboxRef }, filteredOptions.length ? (filteredOptions.map((item, index) => (react_1.default.createElement("li", { key: item.value, className: (0, classnames_1.default)('c-select__item', {
                '-disabled': item.disabled,
            }), "aria-selected": value === item.value, "aria-disabled": item.disabled, "aria-label": item.value, role: "option", ref: (el) => (listitemRef.current[index] = el), value: item.value, tabIndex: 0, onMouseDown: (e) => e.preventDefault(), onClick: () => {
                var _a;
                if (!item.disabled) {
                    onItemClick(item.value);
                    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, item.value);
                }
            } },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('c-option', {
                    '-last': filteredOptions.length === index + 1,
                }) },
                item.icon &&
                    react_1.default.cloneElement(item.icon, Object.assign({ className: `float-left pr-3 ${item.icon.props.className}` }, item.icon.props)),
                react_1.default.createElement("div", { className: "c-option__description" },
                    item.description && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("small", null, item.description),
                        react_1.default.createElement("br", null))),
                    item.value)))))) : (react_1.default.createElement("li", { className: "c-select__item" },
            react_1.default.createElement("div", { className: "c-option" },
                react_1.default.createElement("p", null, "Nenhuma op\u00E7\u00E3o encontrada")))))));
});
//# sourceMappingURL=index.js.map